import {IRouletteBet} from "./IRouletteBet";

export class StraightBet implements IRouletteBet {
    constructor(public chosenNumber: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/StraightBet.ts